export const MAIN_CLASS_NAME = 'project-card';
export const EXTRA_CLASS_NAME = `${MAIN_CLASS_NAME}__extra`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const COPY_ID_BUTTON_CLASS_NAME = `${FOOTER_CLASS_NAME}__copy-id-button`;

export const TRANSLATION_GROUP_PREFIX = 'Project: Card:';
